/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Flat stepper (redesign §2.4): the blue gradient card + colored shadow the template used
// here was the last piece of that chrome on the payment flow. The step marks now carry the
// progress, so the container is just spacing.
import pxToRem from "assets/theme-dark/functions/pxToRem";

const stepper = {
  styleOverrides: {
    root: {
      background: "transparent",
      padding: `${pxToRem(8)} 0 ${pxToRem(16)}`,
      boxShadow: "none",

      "&.MuiPaper-root": {
        backgroundColor: "transparent",
      },
    },
  },
};

export default stepper;
